// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__83iuS","window":"modal_window__G2ias","modal":"modal_modal__OcmYl","open":"modal_open__VyXpE","close":"modal_close__V6EJ9"};